var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialShareFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.69592 13.2478C9.62392 13.2478 8.03992 13.2478 7.31992 13.2478C6.93592 13.2478 6.81592 13.1038 6.81592 12.7438C6.81592 11.7838 6.81592 10.7998 6.81592 9.83983C6.81592 9.45583 6.95992 9.33583 7.31992 9.33583H9.69592C9.69592 9.26383 9.69592 7.87183 9.69592 7.22383C9.69592 6.26383 9.86392 5.35183 10.3439 4.51183C10.8479 3.64783 11.5679 3.07183 12.4799 2.73583C13.0799 2.51983 13.6799 2.42383 14.3279 2.42383H16.6799C17.0159 2.42383 17.1599 2.56783 17.1599 2.90383V5.63983C17.1599 5.97583 17.0159 6.11983 16.6799 6.11983C16.0319 6.11983 15.3839 6.11983 14.7359 6.14383C14.0879 6.14383 13.7519 6.45583 13.7519 7.12783C13.7279 7.84783 13.7519 8.54383 13.7519 9.28783H16.5359C16.9199 9.28783 17.0639 9.43183 17.0639 9.81583V12.7198C17.0639 13.1038 16.9439 13.2238 16.5359 13.2238C15.6719 13.2238 13.8239 13.2238 13.7519 13.2238V21.0478C13.7519 21.4558 13.6319 21.5998 13.1999 21.5998C12.1919 21.5998 11.2079 21.5998 10.1999 21.5998C9.83992 21.5998 9.69592 21.4558 9.69592 21.0958C9.69592 18.5758 9.69592 13.3198 9.69592 13.2478V13.2478Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialShareFb);
export default __webpack_public_path__ + "static/media/social-share-fb.74faf91f83bdfab0d35f089c8f172007.svg";
export { ForwardRef as ReactComponent };